import { Component } from '@angular/core';

@Component({
    selector: 'app-group-skeleton',
    standalone: false,
    templateUrl: './group-skeleton.component.html',
    styleUrl: './group-skeleton.component.scss',
})
export class GroupSkeletonComponent {}
